/* 
 * @Author: 曹俊杰 
 * @Date: 2022年8月23日
 * @Module: 主做平台
 */
 <template>
  <div>
    <el-select style="width:100%;" filterable value-key="platformId" :value="value" multiple placeholder="请选择主做平台" clearable @change="change">
      <el-option v-for="item in platformList" :key="item.platformId" :label="item.name" :value="item.platformId">
        <span style="float: left">{{ item.name }}</span>
        <span style="float: right; color: #8492a6; font-size: 13px" @click.stop="()=>onDelete(item)">删除</span>
      </el-option>
    </el-select>
    <el-button type="text" icon="el-icon-circle-plus-outline" size="mini" style="float:right;" round @click="add">添加主做平台</el-button>
  </div>
</template>
 <script>
export default {
  components: {},
  props: {
    value: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      platformList: [],
      loading: false
    };
  },

  mounted () {
    this.getPlatformList()
  },
  methods: {
    async getPlatformList () {
      this.loading = true;
      const { status, data } = await this.$api.getPlatformList()
      if (status == 200) {
        this.platformList = data
      }
      this.loading = false;
    },
    change (value) {
      this.$emit('input', value)
    },
    async add () {
      try {
        const { value: name } = await this.$prompt('请输入主做平台名称', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        })
        this.loading = true;
        const { status, info } = await this.$api.postPlatform({ name })
        if (status === 200) {
          this.$message({
            type: 'success',
            message: info
          })
          this.getPlatformList();
        } else {
          this.$message({
            type: 'error',
            message: info
          })
        }
      } catch (error) {
        console.log(error)
      }
      this.loading = false;
    },
    async onDelete (res) {
      try {
        await this.$confirm(`此操作将永久删除该选项《${res.name}》, 是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        this.loading = true;
        const { status, info } = await this.$api.deletePlatform({ platformId: res.platformId })
        if (status === 200) {
          this.$message({
            type: 'success',
            message: info
          })
          this.getPlatformList()
        } else {
          this.$message({
            type: 'error',
            message: info
          })
        }
        this.loading = false;
      } catch (error) {
        console.log(error)
      }

    }
  },
};
 </script>
 <style lang='scss' scoped>
</style>